<template>
  <div>
    <GridVx
      ref="agGrid"
      :auto-size-cell="true"
      :columns="columnDefs"
      :rows="recordRowsData"
      :context="context"
      class="agGrid"
      dom-layout="scroll"
      style="height: 300px"
    />
  </div>
</template>
<script>
import {
  CellRenderCheckbox,
  CellRenderVxCurrencyInput,
  CellRenderDeleteIcon,
  CellRenderSelect,
  CellRenderSelectWithSearchTable,
  CellRenderEditIcon,
  CellRenderTextInput
} from '@/utils/cellRenders'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderEditIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelectWithSearchTable,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderVxCurrencyInput
  },
  props: {
    recordRows: [],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      context: null,
      rows: [],
      columnDefs: [
        {
          headerName: 'Ngày',
          field: 'date'
        },
        {
          headerName: 'Giá',
          field: 'price',
          cellRenderer: 'CellRenderVxCurrencyInput',
          cellRendererParams: params => {
            return {
              disabled: this.disabled
            }
          },
          readOnly: false
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: params => {
            return {
              disabled: this.disabled
            }
          }
        },
        {
          headerName: 'Giảm giá (%)',
          field: 'percent_discount',
          cellRenderer: 'CellRenderVxCurrencyInput',
          cellRendererParams: params => {
            return {
              disabled: this.disabled
            }
          }
        },
        {
          headerName: 'Giảm giá (Tiền)',
          field: 'amount_discount',
          cellRenderer: 'CellRenderVxCurrencyInput',
          cellRendererParams: params => {
            return {
              disabled: this.disabled
            }
          }
        },
        {
          headerName: 'Lý do giảm giá',
          field: 'discount_reason',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: params => {
            return {
              disabled: this.disabled
            }
          }
        }
      ]
    }
  },
  computed: {
    recordRowsData() {
      // Force reactivity when prop changes
      return this.recordRows || []
    }
  },
  watch: {
    recordRows: {
      handler(newVal) {
        // GridVx component sẽ tự động cập nhật khi prop rows thay đổi
        // Nhưng để chắc chắn, ta force refresh grid nếu có gridApi
        this.$nextTick(() => {
          if (this.$refs.agGrid && this.$refs.agGrid.gridApi) {
            this.$refs.agGrid.gridApi.refreshCells({ force: true })
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // Initialize grid with data
    this.$nextTick(() => {
      if (this.$refs.agGrid && this.$refs.agGrid.gridOptions) {
        this.$refs.agGrid.gridOptions.api.setRowData(this.recordRows || [])
      }
    })
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  methods: {
    onSelectionChanged(row, event) {
      this.$emit('recordSelected', event)
    },
    changeCheckbox(colName, params, value) {
      this.$emit('updateRow', colName, params, value)
    },
    textInputChange(params, value, colName) {
      this.$emit('updateRow', colName, params, value)
    },
    changeCurrencyInput(params, value, colName) {
      this.$emit('updateRow', colName, params, value)
    },
    SelectInputChange(colName, params, value) {
      this.$emit('updateRow', colName, params, value)
    },

    // handle CellRenderVxCurrencyInput's event
    onBlurCurrencyInput(params, value, colName) {
      console.log('onBlurCurrencyInput', params, value, colName)
      this.$emit('updateRow', colName, params, value)
    },

    onChangeCurrencyInput(params, value, colName) {
      // this.$emit('updateRow', colName, params, value)
    },
    onFocusCurrencyInput(params, value, colName) {
      console.log('onFocusCurrencyInput', params, value, colName)
    }
  }
}
</script>
